import http from "../utils/http";
import { toast } from "../utils/toast";
// 나의 출퇴근 관리 목록 (달력) - 일반사용자
export const getWorkHistoryCommuteCalendarList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/work/history/commute/my/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 전직원 출퇴근 관리 목록 (달력) - 관리자?
export const getWorkHistoryCommuteAllList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/work/history/commute/all/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 변경요청 리스트
export const getWorkRequestList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/work/request/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 출퇴근 등록 - 일반 사용자
export const createWorkHistoryCommute = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/work/history/commute", body)
      .then((res) => {
        // 출근 퇴근 구분이 필요하여 로직상 토스트
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 나의 최근 출퇴근 기록 가져오기
export const getWorkHistoryCommute = () => {
  return new Promise((resolve, reject) => {
    http
      .get("/work/history/commute")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 출퇴근 관리 목록 - 관리자
export const getWorkHistoryCommuteList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/work/history/commute/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 출퇴근 관리 목록 - 다운로드
export const getWorkHistoryCommuteListDownloads = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/work/history/commute/list/downloads", body, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 출퇴근 등록 수정 - 관리자
export const createWorkHistoryCommuteAdmin = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/work/history/commute/admin", body)
      .then((res) => {
        toast.success("출퇴근 기록이 등록되었습니다.")
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 출퇴근 수정 - 관리자
export const modifyWorkHistoryCommuteAdmin = (historyIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/work/history/commute/admin/${historyIdx}`, body)
      .then((res) => {
        toast.success("출퇴근 기록이 수정되었습니다.")
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 출퇴근 삭제 - 관리자
export const deleteWorkHistoryCommuteAdmin = (historyIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/work/history/commute/admin/${historyIdx}`)
      .then((res) => {
        toast.success("출퇴근 기록이 삭제되었습니다.")
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 근무 기록 일괄 목록
export const getWorkHistoryList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/work/history/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 근무 기록 일괄 수정
export const modifyWorkHistory = (body) => {
  return new Promise((resolve, reject) => {
    http
      .put('/work/history', body)
      .then((res) => {
        toast.success("근무 기록이 수정되었습니다.")
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 근무 기록 일괄 삭제
export const deleteWorkHistory = (historyIdxs) => {
  return new Promise((resolve, reject) => {
    http
      .delete('/work/history', {
        data: {
          historyIdxs
        }
      })
      .then((res) => {
        toast.success("근무 기록이 삭제되었습니다.")
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};